var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _AbstractComponentBuilder_state;
export class AbstractComponentBuilder {
    constructor(id, type) {
        this.id = id;
        this.type = type;
        _AbstractComponentBuilder_state.set(this, {});
    }
    setLabel(label) {
        __classPrivateFieldGet(this, _AbstractComponentBuilder_state, "f").label = label;
        return this;
    }
    setPlaceholder(placeholder) {
        __classPrivateFieldGet(this, _AbstractComponentBuilder_state, "f").placeholder = placeholder;
        return this;
    }
    patch(state) {
        __classPrivateFieldSet(this, _AbstractComponentBuilder_state, {
            ...__classPrivateFieldGet(this, _AbstractComponentBuilder_state, "f"),
            ...state,
        }, "f");
        return this;
    }
    state() {
        return {
            ...__classPrivateFieldGet(this, _AbstractComponentBuilder_state, "f"),
        };
    }
    isValid() {
        const { label } = __classPrivateFieldGet(this, _AbstractComponentBuilder_state, "f");
        return this.createValidationResponse()
            .withCheck('label should be defined', () => !!label)
            .withCheck('id should be defined', () => !!this.id)
            .withCheck('type should be defined', () => !!this.type)
            .validate();
    }
    createValidationResponse() {
        const checks = [];
        let initialValidationState = {
            valid: true,
            messages: [],
        };
        const response = {
            withParentValidation: (_response) => {
                if (_response) {
                    // mb merge, but needed atm
                    initialValidationState = { ..._response };
                }
                return response;
            },
            withCheck: (message, validate) => {
                checks.push({ message, validate });
                return response;
            },
            validate: () => {
                return checks.reduce((acc, check) => {
                    if (!check.validate()) {
                        acc.valid = false;
                        acc.messages.push(check.message);
                    }
                    return acc;
                }, {
                    ...initialValidationState,
                    id: this.id ?? 'UNKNOWN_FORM_COMPONENT_ID',
                    type: this.type ?? 'UNKNOWN_FORM_COMPONENT_TYPE',
                });
            },
        };
        return response;
    }
    build() {
        return {
            id: this.id,
            type: this.type,
            ...__classPrivateFieldGet(this, _AbstractComponentBuilder_state, "f"),
        };
    }
}
_AbstractComponentBuilder_state = new WeakMap();
//# sourceMappingURL=AbstractComponentBuilder.js.map